import React, { useState } from 'react';
import cx from 'classnames';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useTranslation } from '@/hooks/translation';
import { useCurrentUser } from '@/hooks/user';
import LoginModal from '@separate/components/LoginModal';
import styles from './floatingButton.module.scss';


const FloatingButton = ({ className }) => {
  const [showLogin, setShowLogin] = useState(false);
  const { t } = useTranslation();
  const { isLoggedIn } = useCurrentUser();
  const { push } = useRouter();
  const hideLogin = () => setShowLogin(false);
  const handleClick = () => {
    isLoggedIn ? push("/qa") : setShowLogin(true);
  };

  return (
    <>
      <button className={cx(className, styles.floatingButtonDesign)} onClick={handleClick}>
        {t(isLoggedIn ? "articles.floatingButton.isLoggedIn" : "articles.floatingButton.guest")}
      </button>
      <LoginModal show={showLogin} onHide={hideLogin} />
    </>
  )
}

export default FloatingButton;

FloatingButton.propTypes = {
  className: PropTypes.string,
}
